/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconDeviceIpadHorizontalOff = createReactComponent("outline", "device-ipad-horizontal-off", "IconDeviceIpadHorizontalOff", [["path", { "d": "M8 4h12a2 2 0 0 1 2 2v12m-2 2h-16a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2", "key": "svg-0" }], ["path", { "d": "M9 17h6", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

export { IconDeviceIpadHorizontalOff as default };
//# sourceMappingURL=IconDeviceIpadHorizontalOff.mjs.map
